import axios from '../util/axiosConfig';
import Moment from 'moment';
import { message } from 'antd';

export const fetchPatientVisitsAPI = async (patientId) => {

    return await axios.get(`/api/v1/receptionist/fetch-patient-visits`, {
        params: {
            patientId: patientId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, visits: response.data }
            }
            else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error }
        });

}

export const fetchPatientDetails = async (patientId) => {
  try {
    const response = await axios.get(`/api/v1/patients/${patientId}`);

    if (response.data) {
      return { success: true, patient: response.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return { success: false, error };
  }
};

export const addUpdateVisitAPI = async (visit) => {

    if (visit.visitNo === 0) {
        for (var i = 0; i < visit.examinations.length; i++) {
            visit.examinations[i]['examinationId'] = 0;
        }
    }

    return await axios.post(`/api/v1/receptionist/add-update-visit`, visit)
        .then(function (response) {

            if (response.data) {
                return { success: true, visit: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}
export const fetchPatientsBySearchAPI = async (searchObj) => {
    let { dob, firstName, lastName,patientId } = searchObj;


    return await axios.get(`/api/v1/search-patients`, {
        params: {
            DOB: dob !== null ? Moment(searchObj.dob).format('YYYY-MM-DD') : null,
            firstName: firstName === "" ? null : firstName,
            lastName: lastName === "" ? null : lastName,
            patientId: patientId ? patientId: null
        }

    }).then(function (response) {


        if (response.data) {
            return { success: true, patients: response.data }
        } else {
            return {
                success: false
            }
        }
    }).catch(function (error) {
        return { success: false }
    })
}

export const addNewPatientAPI = (patient) => {
    let modifiedPatient = { ...patient };

    return axios.post(`/api/v1/add-update-patient`, modifiedPatient)
        .then(function (response) {
            if (response.data) {
                return { success: true, patient: response.data };
            } else {
                return { success: false, 'error': response };
            }

        }).catch(function (error) {

            return { success: false, 'error': error };
        });
}

export const syncAmrNotesAPI = async (payload) => {    
    return await axios.post(`/api/v1/sync-amr-notes`, payload)
    .then(function (response){
        if (response.status === 200) {            
            return { success: true, data: response.data };
        } else {
            return { success: false };
        }
    }).catch(function (error) {
        return { success: false };
    });
}

export const deletePatientExaminationAPI = async (examinationId) => {

    return await axios.get(`/api/v1/delete-patient-examinations`, {
        params: {
            "examinationIds": examinationId
        }
    }).then(function (response) {

        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false };
        }
    })
        .catch(function (error) {
            return { success: false };
        });
}

export const mergePatientsAPI = async (toBeDeletedPatientId, retainedPatientId) => {

    return await axios.post(`/api/v1/merge-patients?toBeDeletedPatientId=${toBeDeletedPatientId}&retainedPatientId=${retainedPatientId}`)
        .then(function (response) {
            console.log('API response', response);
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const uploadPatientDocumentAPI = (documents, patientId) => {

    return axios.post(`/api/v1/upload-patient-documents`, documents, {
         headers: {'Content-Type': 'multipart/form-data'}
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, patient: response.data };
            } else {
                return { success: false };
            }

        })
}

// export const uploadAppointmentDocumentAPI = (documents) => {

//     return axios.post(`/api/v1/upload-appointment-document`, documents)
//         .then(function (response) {
//             if (response.data) {
//                 return { success: true, appointment: response.data };
//             } else {
//                 return { success: false };
//             }

//         })
// }

export const uploadAppointmentDocumentAPI = async (document) => {
    return await axios.post(`/api/v1/upload-appointment-document`, document, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const getPatientDocumentsAPI = async (patientId) => {

    return await axios.get(`/api/v1/patient-documents`, {
        params: {
            "patientId": patientId
        }
    }).then(function (response) {

        const documents = Array.isArray(response.data)
            ? response.data
            : response.data?.content;
        if (Array.isArray(documents)) {
            return { success: true, data: documents };
        }
        return { success: false };
    })
        .catch(function (error) {
            return { success: false };
        });
}

export const uploadVisitDocumentAPI = async (document) => {
    return await axios.post(`/api/v1/upload-visit-document`, document, {
        headers: {'Content-Type': 'multipart/form-data'}
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const fetchPatientNotesAPI = async (patientId) => {
    return await axios.get(`/api/v1/patient-notes`, {
        params: {
            "patientId": patientId
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const addUpdatePatientNotesAPI = (notes) => {
    return axios.post(`/api/v1/add-update-patient-notes`, notes)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        }).catch(function (error) {
            return { success: false };
        });
}

export const deleteAppointmentDocumentAPI = async (documentId) => {
    return await axios.delete(`/api/v1/appointment-document`, {
        params: {
            "documentId": documentId
        }
    })
        .then(function (response) {

            if (response.status === 200) {
                return { success: true};
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const deleteVisitDocumentAPI = async (documentId, visitNo) => {
    return await axios.get(`/api/v1/delete-visit-document`, {
        params: {
            "documentId": documentId,
            'visitNo': visitNo
        }
    })
        .then(function (response) {
            if (response.data === true) {
                return { success: true};
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const deletePatientDocumentAPI = async (documentId, patientId) => {

    return await axios.get(`/api/v1/delete-patient-document`, {
        params: {
            "documentId": documentId,
            'patientId': patientId
        }
    })
        .then(function (response) {
            console.log('API response', response);
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const createHL7MessageAPI = async (visitNo) => {

    return await axios.get(`/api/v1/orm-hl7`, {
        params: {
            'visitId': visitNo
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const downloadDraftReportAPI = async (reportId) => {

    return await axios({
        url: '/api/v1/download-patient-report',
        method: 'GET',
        responseType: 'blob',
        params: {
            reportId
        }
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = reportId + '.pdf';
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
    }).catch(function (error) {
        message.error('Failed to download file!');
        return { success: false }
    });
}

export const fetchVisitInvoicesAPI = async (orderNo) => {
    return await axios.get(`/api/v1/visits/${orderNo}/invoice`, {
        params: {
            orderNo
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, invoices: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}

export const deleteInvoiceAPI = async (invoiceId) => {
    return await axios.get(`/api/v1/visits/cancel-invoice/${invoiceId}`, {
        params: {
            invoiceId
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}

export const fetchVisitAuditInfoAPI = async (orderNo) => {
    return await axios.get(`/api/v1/visit-audit`, {
        params: {
            visitNo: orderNo
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, auditInfo: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}

export const fetchAppointmentNotesAPI = async (appointmentId) => {
    return await axios.get(`/api/v1/appointment-notes`, {
        params: {
            appointmentId
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, appointmentNotes: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}

export const fetchInvoiceReceiptsAPI = async (invoiceId) => {

    return await axios.post(`/api/v1/invoice/${invoiceId}/receipts`, invoiceId)
        .then(function (response) {

            if (response.data) {
                return { success: true, receipts: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, 'error': error };
        });
}

export const searchPatientAPI = async (patientId) => {

    return await axios.get(`/api/v1/patients/${patientId}`, {
        params: {
            patientId
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, patient: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false };
        });
}

export const sendEDIAPI = async (data) => {
    return await axios.get(`/api/v1/send-edi`, {
        params: {
            ...data
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
}

export const sendEDIManuallyAPI = async (data) => {
    return await axios.get('/api/v1/sent-edi-manually', {
        params: {
            visitNo: data.visitNo,
            providerNumber: data.providerNumber
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
}
export const sendFaxAPI = async (data) => {
    return await axios.get(`/api/v1/send-fax`, {
        params: {
            ...data
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
}

export const updateInvoiceDetails = async (event) => {
    console.log('event', event)
    return await axios.post(`/api/v1/update-invoice`, event, {responseType:'blob'})
        .then(function (response) {
            if (response.data) {
                console.log('data', response.data)
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                let fileName = `INV${event.orderNo}` + '.pdf';
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                return { success: true };  
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
  }

  export const closeNonReportingVisit = async (data) => {
    return await axios.post(`/api/v1/close-non-reporting-visit`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
}

export const addAppointmentNote = async (payload) => {
    return await axios.post(`/api/v1/add-appointment-notes`, payload)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const changeCreatedDateForVisitAPI = async (data) => {
    return await axios.get(`/api/v1/update-visit-arrived-date`, {
        params: {
            ...data
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
}

export const suggestPatientAddress = async (data) => {
    return await axios.get(`/api/v1/patients/address/suggest`, {
        params: {
            ...data
        }
    })
        .then(function (response) {

            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
}

export const addPatientReferralAPI = async (referral, referralDetailId) => {
    const params = referralDetailId ? { referralDetailId } : {};
    return await axios.post(`/api/v1/add-update-referral-details`, 
        referralDetailId ? { ...referral, referralDetailId: referralDetailId } : referral
    )
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getReferralDetailsAPI = async (page = 0, size = 20, searchText, sortKey, sortBy, mipId) => {
    const params = { page, size };
    if (searchText) params.searchText = searchText;
    if (sortKey) params.sortKey = sortKey;
    if (sortBy) params.sortBy = sortBy;
    if (mipId) params.mipId = mipId;
    return await axios.get(`/api/v1/get-referrals`, {
        params
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getReferralByIdAPI = async (referralDetailId) => {
    return await axios.get(`/api/v1/get-referral-details`, {
        params: {
            referralDetailId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const uploadReferralDocumentAPI = async (formData) => {
    return await axios.post(`/api/v1/upload-referral-document`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getReferralDocumentsByReferralIdAPI = async (referralDetailId) => {
    return await axios.get(`/api/v1/get-referral-document`, {
        params: {
            referralDetailId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const syncReferralDocumentsToAppointmentAPI = async (referralDetailId) => {
    return await axios.post(`/api/v1/sync-referral-documents-to-appointment`, null, {
        params: { referralDetailId }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getReferralsByPatientIdAPI = async (patientId, machineId) => {
    return await axios.get(`/api/v1/get-referrals-by-patientId`, {
        params: {
            patientId,
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const syncReferralDocumentsToVisitAPI = async ({ referralDetailId, visitNo }) => {
    return await axios.post(`/api/v1/sync-referral-documents-to-visit`, null, {
        params: { referralDetailId, visitNo }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const deleteReferralDocumentAPI = async (documentId) => {
    return await axios.delete(`/api/v1/referral-document`, {
        params: {
            documentId
        }
    })
        .then(function (response) {
            if (response.status === 200) {
                return { success: true };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getReferralsByAppointmentIdAPI = async (appointmentId) => {
    return await axios.get(`/api/v1/get-referrals-by-appointmentId`, {
        params: {
            appointmentId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}
